import { AuthGuard } from './auth.guard';
import { PermissionGuard } from '@shared/guards/permission.guard';

export const GUARDS = [AuthGuard, PermissionGuard];

export { AuthGuard, PermissionGuard };
